/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUpdateHashRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'
import {GetUpdateHashResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'


export const getUpdateHash = (request: GetUpdateHashRequest, options?: CashRequestOptions) => post<GetUpdateHashRequest, GetUpdateHashResponse>("/2.0/cash/get-update-hash", request, {...options, rejectOnError: true })